export type RevenueMetricsSectionKey =
  | "revenueOverTime"
  | "totalRevenue"
  | "topCustomers"
  | "customerGrowth"
  | "revenueBreakdown";

export type RevenueMetricsSection = {
  key: RevenueMetricsSectionKey;
  label: string;
};

export const REVENUE_METRICS_SECTIONS: RevenueMetricsSection[] = [
  { key: "totalRevenue", label: "Total Revenue" },
  { key: "topCustomers", label: "Top customers by revenue" },
  { key: "customerGrowth", label: "Customer growth" },
  { key: "revenueBreakdown", label: "Revenue breakdown" },
];

export const DEFAULT_REVENUE_METRICS_ORDER: RevenueMetricsSectionKey[] =
  REVENUE_METRICS_SECTIONS.map((s) => s.key);

export const DEFAULT_REVENUE_METRICS_VISIBLE: Record<
  RevenueMetricsSectionKey,
  boolean
> = Object.fromEntries(
  REVENUE_METRICS_SECTIONS.map((s) => [s.key, true])
) as Record<RevenueMetricsSectionKey, boolean>;
